/**
 * Site configuration for multi-domain deployment
 * @author dongdong.fdd
 * @date 2025/2/19
 */

export const ENGLISH_SITE_DOMAINS = ['postanything.net', 'www.postanything.net'];

/**
 * Returns true when the current hostname is the English site (postanything.net)
 */
export function isEnglishSite(): boolean {
  if (typeof window === 'undefined') return false;
  return ENGLISH_SITE_DOMAINS.includes(window.location.hostname);
}
